import type { RoofColorView } from "@slfinrtl/ui-bff-routes"
import { ErrorNotificationInline } from "src/context/errorHandler/ErrorNotificationInline"
import { withErrorHandler } from "src/context/errorHandler/withErrorHandler"
import type { OrderType } from "../../OrderType"
import { useSelectCatalogRoofColor } from "./useSelectCatalogRoofColor"
import { SelectCatalogRoofColor } from "./view/SelectCatalogRoofColor"
import { SelectCatalogRoofColorSkeleton } from "./view/SelectCatalogRoofColorSkeleton"

export interface SelectCatalogRoofColorContainerProps {
	currentRoofColor: RoofColorView | undefined
	inventoryId: string
	onRoofColorSelected: (roofColor: RoofColorView) => void
	orderType: OrderType
	showCustomRoofColorContainer: () => void
}

export const SelectCatalogRoofColorContainer = withErrorHandler((props: SelectCatalogRoofColorContainerProps) => {
	const viewProps = useSelectCatalogRoofColor(props)

	return (
		<>
			<ErrorNotificationInline />
			{viewProps ? <SelectCatalogRoofColor {...viewProps} /> : <SelectCatalogRoofColorSkeleton />}
		</>
	)
})
